import React, { StrictMode } from 'react';

import PageTitleNew from 'components/ui/PageTitleNew';
import Table from './Table';
import Context from './Context';

export default function Index() {
  return (
    <StrictMode>
      <Context>

        <div className="wrapper_assestment invite_wrapper">
          <PageTitleNew title="Invoices for LeggUP" />

          <Table />
        </div>
      </Context>
    </StrictMode>
  );
}
